import { render, staticRenderFns } from "./FontSizeCtrl.vue?vue&type=template&id=7499945a&"
import script from "./FontSizeCtrl.vue?vue&type=script&lang=js&"
export * from "./FontSizeCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports